import React, { useState, useEffect } from "react";
import { cilX } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import Select from "./form/Select";
import Text from "./form/Text";
import { getDisplayQuestions } from "src/services/Questionnaire/GetDisplayQuestions";

const Sidebar = ({
  isOpen,
  modalData,
  review,
  validationErrors,
  toggleSidebar,
}) => {
  const [displayQuestions, setDisplayQuestions] = useState([]);

  useEffect(() => {
    if (review && modalData.questions) {
      setDisplayQuestions(getDisplayQuestions(modalData?.questions, review));
    }
  }, [review, modalData.questions]);

  var filteredItems = [];
  if (modalData?.questions) {
    filteredItems = modalData?.questions.filter((item) =>
      displayQuestions?.includes(item.id)
    );
  }

  const sidebarStyle = {
    height: "100%",
    width: "350px",
    top: 70,
    position: "fixed",
    right: isOpen ? "0" : "-350px",
    backgroundColor: "white",
    overflowX: "scroll",
    transition: "0.2s",
  };

  return (
    <div style={sidebarStyle}>
      <div className="card m-2 mb-4">
        <div
          className="card-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>Document Review</div>
          <div>
            <CIcon
              icon={cilX}
              className="me-2"
              onClick={toggleSidebar}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>

        <div className="card-body">
          <form>
            <div className="row mb-2">
              <div className="col-md-12">
                {filteredItems &&
                  filteredItems?.map((question, index) => (
                    <div className="form-group" key={index}>
                      {(question.type == "S" ||
                        question.type == "M" ||
                        question.type == "ST") && (
                        <Select
                          data={review?.[question.id]}
                          options_mapping={question.options}
                          name={question.id}
                          label={question.label}
                          handleInputChange={modalData?.handleInputChange}
                          width={100}
                          multiple={
                            question.type == "S" || question.type == "ST"
                              ? false
                              : true
                          }
                          is_invalid={
                            validationErrors[question.id] ? true : false
                          }
                        />
                      )}
                      {question.type == "T" && (
                        <Text
                          data={review?.[question.id]}
                          name={question.id}
                          label={question.label}
                          handleInputChange={modalData?.handleInputChange}
                          width={60}
                          type="text"
                          is_invalid={
                            validationErrors[question.id] ? true : false
                          }
                        />
                      )}
                      {question.type == "N" && (
                        <Text
                          data={review?.[question.id]}
                          name={question.id}
                          label={question.label}
                          handleInputChange={modalData?.handleInputChange}
                          width={60}
                          type="number"
                          is_invalid={
                            validationErrors[question.id] ? true : false
                          }
                        />
                      )}
                      {question.type == "D" && (
                        <Text
                          data={review?.[question.id]}
                          name={question.id}
                          label={question.label}
                          handleInputChange={modalData?.handleInputChange}
                          width={60}
                          type="date"
                          is_invalid={
                            validationErrors[question.id] ? true : false
                          }
                          onFocus={(e) => e.target.showPicker && e.target.showPicker()}
                        />
                      )}
                      <br></br>
                    </div>
                  ))}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
